import ReactGA from "react-ga4";
import Cookies from "js-cookie";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;

let gaReady = false;

// GA ruleaza doar dupa consimtamant explicit (cookie cookieConsent === 'accepted').
const hasConsent = () => Cookies.get("cookieConsent") === "accepted";

export const initGA = () => {
  if (!GA_MEASUREMENT_ID || !hasConsent() || gaReady) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
  gaReady = true;
};

export const trackPage = (path) => {
  if (!GA_MEASUREMENT_ID || !hasConsent()) return;
  initGA();
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

export const trackEvent = (action, category, label) => {
  if (!GA_MEASUREMENT_ID || !hasConsent()) return;
  initGA();
  ReactGA.event({
    action,
    category,
    label,
  });
};

// Apelat de bannerul de cookie-uri la "Accept": porneste GA si trimite pagina curenta.
export const onConsentAccepted = () => {
  initGA();
  trackPage(window.location.pathname + window.location.search);
};
